/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/IStripeCustomerBean', 'model/StripeCustomerMetadataBean', 'model/StripeDiscountBean', 'model/StripeSubscriptionBean', 'model/StripeTaxIdBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./IStripeCustomerBean'), require('./StripeCustomerMetadataBean'), require('./StripeDiscountBean'), require('./StripeSubscriptionBean'), require('./StripeTaxIdBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.StripeCustomerResponse = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.IStripeCustomerBean, root.BpmbuildProductionappspotcom.StripeCustomerMetadataBean, root.BpmbuildProductionappspotcom.StripeDiscountBean, root.BpmbuildProductionappspotcom.StripeSubscriptionBean, root.BpmbuildProductionappspotcom.StripeTaxIdBean);
  }
}(this, function(ApiClient, IStripeCustomerBean, StripeCustomerMetadataBean, StripeDiscountBean, StripeSubscriptionBean, StripeTaxIdBean) {
  'use strict';

  /**
   * The StripeCustomerResponse model module.
   * @module model/StripeCustomerResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeCustomerResponse</code>.
   * @alias module:model/StripeCustomerResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeCustomerResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeCustomerResponse} obj Optional instance to populate.
   * @return {module:model/StripeCustomerResponse} The populated <code>StripeCustomerResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('preferredLocales'))
        obj.preferredLocales = ApiClient.convertToType(data['preferredLocales'], 'String');
      if (data.hasOwnProperty('address.postal_code'))
        obj.addressPostalCode = ApiClient.convertToType(data['address.postal_code'], 'String');
      if (data.hasOwnProperty('invoice_settings.default_payment_method'))
        obj.invoiceSettingsDefaultPaymentMethod = ApiClient.convertToType(data['invoice_settings.default_payment_method'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('tax_exempt'))
        obj.taxExempt = ApiClient.convertToType(data['tax_exempt'], 'String');
      if (data.hasOwnProperty('metadata'))
        obj.metadata = StripeCustomerMetadataBean.constructFromObject(data['metadata']);
      if (data.hasOwnProperty('invoice_prefix'))
        obj.invoicePrefix = ApiClient.convertToType(data['invoice_prefix'], 'String');
      if (data.hasOwnProperty('invoice_settings.custom_fields.value'))
        obj.invoiceSettingsCustomFieldsValue = ApiClient.convertToType(data['invoice_settings.custom_fields.value'], 'String');
      if (data.hasOwnProperty('delinquent'))
        obj.delinquent = ApiClient.convertToType(data['delinquent'], 'Boolean');
      if (data.hasOwnProperty('address.state'))
        obj.addressState = ApiClient.convertToType(data['address.state'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('shipping.address.line1'))
        obj.shippingAddressLine1 = ApiClient.convertToType(data['shipping.address.line1'], 'String');
      if (data.hasOwnProperty('phone'))
        obj.phone = ApiClient.convertToType(data['phone'], 'String');
      if (data.hasOwnProperty('address.country'))
        obj.addressCountry = ApiClient.convertToType(data['address.country'], 'String');
      if (data.hasOwnProperty('stripeCustomerList'))
        obj.stripeCustomerList = ApiClient.convertToType(data['stripeCustomerList'], [IStripeCustomerBean]);
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('subscriptions.data'))
        obj.subscriptionsData = ApiClient.convertToType(data['subscriptions.data'], [StripeSubscriptionBean]);
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('liveMode'))
        obj.liveMode = ApiClient.convertToType(data['liveMode'], 'Boolean');
      if (data.hasOwnProperty('default_source'))
        obj.defaultSource = ApiClient.convertToType(data['default_source'], 'String');
      if (data.hasOwnProperty('object'))
        obj._object = ApiClient.convertToType(data['object'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('address.line2'))
        obj.addressLine2 = ApiClient.convertToType(data['address.line2'], 'String');
      if (data.hasOwnProperty('address.city'))
        obj.addressCity = ApiClient.convertToType(data['address.city'], 'String');
      if (data.hasOwnProperty('invoice_settings.custom_fields.name'))
        obj.invoiceSettingsCustomFieldsName = ApiClient.convertToType(data['invoice_settings.custom_fields.name'], 'String');
      if (data.hasOwnProperty('discount'))
        obj.discount = StripeDiscountBean.constructFromObject(data['discount']);
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('stripeCustomerId'))
        obj.stripeCustomerId = ApiClient.convertToType(data['stripeCustomerId'], 'String');
      if (data.hasOwnProperty('tax_ids.data'))
        obj.taxIdsData = ApiClient.convertToType(data['tax_ids.data'], [StripeTaxIdBean]);
      if (data.hasOwnProperty('balance'))
        obj.balance = ApiClient.convertToType(data['balance'], 'Number');
      if (data.hasOwnProperty('address.line1'))
        obj.addressLine1 = ApiClient.convertToType(data['address.line1'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} preferredLocales
   */
  exports.prototype.preferredLocales = undefined;

  /**
   * @member {String} addressPostalCode
   */
  exports.prototype.addressPostalCode = undefined;

  /**
   * @member {String} invoiceSettingsDefaultPaymentMethod
   */
  exports.prototype.invoiceSettingsDefaultPaymentMethod = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {String} taxExempt
   */
  exports.prototype.taxExempt = undefined;

  /**
   * @member {module:model/StripeCustomerMetadataBean} metadata
   */
  exports.prototype.metadata = undefined;

  /**
   * @member {String} invoicePrefix
   */
  exports.prototype.invoicePrefix = undefined;

  /**
   * @member {String} invoiceSettingsCustomFieldsValue
   */
  exports.prototype.invoiceSettingsCustomFieldsValue = undefined;

  /**
   * @member {Boolean} delinquent
   */
  exports.prototype.delinquent = undefined;

  /**
   * @member {String} addressState
   */
  exports.prototype.addressState = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} shippingAddressLine1
   */
  exports.prototype.shippingAddressLine1 = undefined;

  /**
   * @member {String} phone
   */
  exports.prototype.phone = undefined;

  /**
   * @member {String} addressCountry
   */
  exports.prototype.addressCountry = undefined;

  /**
   * @member {Array.<module:model/IStripeCustomerBean>} stripeCustomerList
   */
  exports.prototype.stripeCustomerList = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Array.<module:model/StripeSubscriptionBean>} subscriptionsData
   */
  exports.prototype.subscriptionsData = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {Boolean} liveMode
   */
  exports.prototype.liveMode = undefined;

  /**
   * @member {String} defaultSource
   */
  exports.prototype.defaultSource = undefined;

  /**
   * @member {String} _object
   */
  exports.prototype._object = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {String} addressLine2
   */
  exports.prototype.addressLine2 = undefined;

  /**
   * @member {String} addressCity
   */
  exports.prototype.addressCity = undefined;

  /**
   * @member {String} invoiceSettingsCustomFieldsName
   */
  exports.prototype.invoiceSettingsCustomFieldsName = undefined;

  /**
   * @member {module:model/StripeDiscountBean} discount
   */
  exports.prototype.discount = undefined;

  /**
   * @member {String} email
   */
  exports.prototype.email = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} stripeCustomerId
   */
  exports.prototype.stripeCustomerId = undefined;

  /**
   * @member {Array.<module:model/StripeTaxIdBean>} taxIdsData
   */
  exports.prototype.taxIdsData = undefined;

  /**
   * @member {Number} balance
   */
  exports.prototype.balance = undefined;

  /**
   * @member {String} addressLine1
   */
  exports.prototype.addressLine1 = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/StripeCustomerResponse.js